<template>

</template>

<script>

    export default {

        data: function () {
            return {
                storage: storage,
                periodicity: {
                    en: 'annual',
                },
                edit: false,
                shift: 0,
                method: 'pearson',
            };
        },

        computed: {
            title: function () {
                return this.storage.title;
            },
            pattern: function () {
                return this.storage.pattern;
            },
            headline: function () {
                return [{
                    dimension: this.title,
                    content: '',
                }];
            }
        },

    }

</script>